import { ReportRerunSummary, ReportSummaryItemApi } from "../api/Reports";
import RerunReportBanner from "../360/RerunReportBanner";

interface Props {
  report: ReportSummaryItemApi;
  reportReruns: ReportRerunSummary[] | undefined;
}

const ReportsSummaryRerunBanner = ({ report, reportReruns }: Props) => (
  <RerunReportBanner
    report={report}
    reportReruns={reportReruns}
    variant="misconduct-summary"
    reportType="misconduct"
  />
);

export default ReportsSummaryRerunBanner;
